import React from 'react'

import styles from './styles/Label.css'

// This component resembles the material UI label since it doesn't come as an 'À la carte' option.
const Label = ({ children }) => {
  return (
    <span className={styles.somethingElse}>{children}</span>
  )
}

export default Label



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/Label.js